<template>
  <!-- 新建生产单-机台项部分 -->
  <el-table
    ref="multipleTable"
    :data="machineList"
    height="500"
    style="width: 100%" border
    @selection-change="handleSelectionChange" :row-style="{height: '0'}"
    :cell-style="{padding: '0px'}" :header-cell-style="{padding: '0px'}">
    <el-table-column type="selection" width="30" align="center"/>
    <el-table-column prop="number" label="机台编号" width="80" align="center"/>
    <el-table-column prop="workshop" label="车间" width="120" align="center"/>
    <el-table-column label="车速(转/分钟)" width="120" align="center">
      <template slot-scope="data">
        <input v-model="data.row.speed" class="table-input"/>
      </template>
    </el-table-column>
    <el-table-column label="落布数(米)" width="120" align="center">
      <template slot-scope="data">
        <input v-model="data.row.dropClothLength" class="table-input" type="number"/>
      </template>
    </el-table-column>
    <el-table-column label="幅宽(毫米)" width="150" align="center">
      <template slot-scope="data">
        <input v-model="data.row.doorWidth" class="table-input" @input="computeDoorWidth(data.row)"/>
      </template>
    </el-table-column>
    <!-- 门幅根据幅宽去计算 -->
    <el-table-column label="门幅数" prop="doorCount" width="50" align="center"/>
    <el-table-column label="预设生产数(米)" width="120" align="center">
      <template slot-scope="data">
        <input v-model="data.row.predictProducedLength" class="table-input" type="number"/>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <!-- <template slot-scope="data">
        <el-button type="primary" @click="resetMachineInfo(data.row)" size="mini">重置</el-button>
      </template> -->
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    props: {
      productOrderLength: {
        default: 0
      }
    },
    data() {
      return {
        machineList: [],
        multipleSelection: []
      }
    },

    methods: {
      // 外部调用，获取机台项数据
      getMachineItems() {
        const formatArr = []
        var sumLength = 0
        this.multipleSelection.forEach(item => {
          formatArr.push({
            machineId: item.id,
            machineNum: item.number,
            workShop: item.workshop,
            speed: item.speed,
            dropClothLength: (item.dropClothLength) * 100,
            doorCount: item.doorCount,
            doorWidth: item.doorWidth,
            predictProducedLength: (item.predictProducedLength) * 100
          })
          sumLength += parseFloat(item.predictProducedLength)
        })
        if (sumLength > this.productOrderLength) {
          return false
        }
        return formatArr
      },
      // 获取机台列表，以供展示
      getMachineList(cache) {
          return this.$requestBase({
            url: 'factory/machine/find',
            method: 'get',
            params: {
              number: ''
            }
          }).then(res => {
            const sortResponse = this._.sortBy(res.data, obj => {
              // 默认升序 降序return的结果加 - ，-obj.machine.number
              // 提取字母 obj.machineNumber.replace(/[^a-z]+/ig,"");
              var machineNumber = obj.number.replace(/[^0-9]+/ig, '')
              return Number(machineNumber)
            })
            if (!this.utils.isEmpty(cache)) {
              this.machineList = this._.assign(sortResponse, cache)
            } else {
              this.machineList = sortResponse
            }
          })
      },
      // 全选事件
      toggleSelection(arr) {
        arr.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      },
      // 单选事件
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 计算幅宽
      computeDoorWidth(row) {
        const width = row.doorWidth
        let widthArr = width.split('*')
        widthArr = this._.remove(widthArr, (item) => {
          return item !== ''
        })
        const length = widthArr.length
        row.doorCount = length === 0 ? '' : length
      }
    },
    created() {
    },
    watch: {
      multipleSelection() {
        const clone = this.multipleSelection
        const length = clone.length
        if (length > 0) {
          // vuex的数据放进来的时候，因为productOrder还未传进来，所以不去改动数据
          const average = this.utils.formatDecimal(this.productOrderLength / length)
          if (average > 0) {
            clone.forEach(item => {
              item.predictProducedLength = average
            })
            this.multipleSelection = clone
          }
        }
      }
    }
  }
</script>

<style scoped>
.table-input {
  height:100%;width:100%;border:0px;outline:none;padding:0;margin:0;
  text-align: center;
}
</style>
